// extracted by mini-css-extract-plugin
export var orderDetails = "_tz-2";
export var orderImage = "_tz-1";
export var orderMeta = "_tz-3";
export var orderSummary = "_tz-0";
export var rightArrow = "_tz-4";